import { Skeleton as InternalSkeleton } from "./Skeleton";
import { SelectSkeleton } from "./common/select";

type InternalSkeletonType = typeof InternalSkeleton;

interface SkeletonType extends InternalSkeletonType {
  SelectSkeleton: typeof SelectSkeleton;
}

const Skeleton = InternalSkeleton as SkeletonType;

Skeleton.SelectSkeleton = SelectSkeleton;

export default Skeleton;
